export const Add_todo = 'Add_todo';
export const Auth_email = 'Auth_email';
export const Todo_Data = "Todo_Data"